import React, { useCallback, useEffect, useState } from 'react'
import SideBar from '../SideBar.js'
import Header from '../../Header/Header.js'
import BillingHeader from './BillingHeader.js'
import Table from "../../components/Table/index.jsx";
import * as XLSX from 'xlsx';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_WALLET_BALANCE, GET_WALLET_TRANSACTION } from '../../graphql/Query/Wallet.js';
import { walletTransactionTableColumns } from '../../components/Constant/index.js';
import { useLocation } from 'react-router-dom';
import { FiDownload } from 'react-icons/fi';
import DateFilter from '../../Common/DateRange.js';
import { getDateRange } from '../../Common/GetDateRange.js';
import moment from 'moment';
import { toast } from 'react-toastify';



const WalletTransactions = () => {
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 30 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const awbNumberData = queryParams.get("awb_number");
    const [orderData, setOrderData] = useState([]);
    const [awbNumber, setawbNumber] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [fetchAllOrders] = useLazyQuery(GET_WALLET_TRANSACTION, {
        fetchPolicy: "cache-and-network"
    });
    const { data: walletData } = useQuery(GET_WALLET_BALANCE, {
        fetchPolicy: "cache-and-network"
    });
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_WALLET_TRANSACTION, {
        variables: {
            page: page,
            limit,
            "sort": { key: "createdAt", type: -1 },
            awbNumber: awbNumberData ? awbNumberData : awbNumber,
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
        },
        fetchPolicy: 'cache-and-network'
    })
    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);
    const handleSearch = (e, awb) => {
        if (awb === 'awbNumber') {
            setawbNumber(e.target.value)
        }
        setPage(1);
    }
    useEffect(() => {
        if (GetOrderOrder?.getWalletTransaction?.data) {
            setOrderData(GetOrderOrder?.getWalletTransaction?.data);
        }
    }, [GetOrderOrder]);
    const handlePagination = (page) => {
        setPage(page?.selected);
    };

    const resetData = () => {
        setPage(1);

        setawbNumber("");
        const defaultRange = getDateRange("Last 30 Days");
        setFinalRange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });
    }
    const transformDataForExport = (data) => {
        return data?.map((shipment, index) => {
            return {
                DATE: moment(shipment?.createdAt).format("DD/MM/YYYY"),
                "TXN TYPE": shipment?.txnType ? shipment?.txnType : "-",
                "REF NO#": shipment?.orderId?.awb_number ? shipment?.orderId?.awb_number : "-",
                "TRANSACTION ID": shipment?.transactionId ? shipment?.transactionId : "-",
                "CREDIT": shipment?.credit ? shipment?.credit : "-",
                "DEBIT": shipment?.debit ? shipment?.debit : "-",
                "CLOSING BALANCE": shipment?.closingBalance ? shipment?.closingBalance : "-",
                "DESCRIPTION": shipment?.description ? shipment?.description : "-",
            };
        });
    };

    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: 1,
                limit: 100000,
                "sort": { key: "createdAt", type: -1 },
                awbNumber: awbNumber,
                from: finalRange?.startDate?.toISOString(), // Use updated startDate
                to: finalRange?.endDate?.toISOString(),
            },
            fetchPolicy: "cache-and-network"
        });

        if (!data?.getWalletTransaction?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getWalletTransaction?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Recharge_logs");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "Recharge_logs.xlsx");
    };

    return (
        <div>
            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}
                <SideBar />

                <div className="flex-1 space-y-3 md:p-6 py-6 overflow-x-hidden ml-16">
                    <div className='bg-white '>
                        <BillingHeader />
                        <div className="flex px-6 md:mt-3 mt-7 mb-3 md:mb-0 justify-end">
                            <button
                                onClick={downloadExcel}
                                className="flex items-center gap-2 text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full md:w-auto"
                            >
                                <FiDownload className="text-lg" /> Export
                            </button>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 px-6 pb-7 lg:grid-cols-2 xl:grid-cols-3 gap-4">

                            <div className="md:space-y-2">
                                <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />
                            </div>
                            {/* AWB No. */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700">AWB No.</label>
                                <input
                                    type="text"
                                    value={awbNumber}
                                    onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber'); }}
                                    placeholder="AWB Nos (comma-separated)"
                                    className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                />
                            </div>
                            <div className="flex items-end h-full" onClick={resetData}>
                                <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                    Reset Filters
                                </p>
                            </div>

                        </div>
                    </div>
                    {/* Main Content */}

                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <div>
                            <p className='font-bold'>Wallet Balance: {Number(walletData?.GetWalletBalanceAmount?.balance.toFixed(2)) || 0.00}</p>
                            <Table
                                columns={walletTransactionTableColumns}
                                data={orderData || []}
                                currentPage={page}
                                totalRecords={GetOrderOrder?.getWalletTransaction?.count || 0}
                                limit={limit}
                                setLimit={setLimit}
                                setPage={setPage}
                                // deleteData={DeleteProduct}


                                handlePagination={handlePagination}
                            // multiSelectRow={onSelectedRowsChange}
                            // multipleId={multipleId}
                            // clearSelectedRows={toggleCleared}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default WalletTransactions;
